import React from 'react';
import DataTable from '~/components/datatable';
import { ListContainer } from '~/views/events/accredit-approval/styles';

export const TabSupplier = ({ supplierList, columns, onRowClicked }) => {
  return (
    <ListContainer>
      <DataTable
        data={{ rows: supplierList }}
        columns={columns}
        noPagination={true}
        emptyText="Nenhum fornecedor credenciado"
        onRowClicked={onRowClicked}
        keyField="company.identify"
        />
    </ListContainer>
  )
};